import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

// Firebase web config is public by design; access is controlled by Firebase security rules and API key restrictions.
const firebaseConfig = {
    apiKey: 'AIzaSyB7BrhW8S7cFLLIQwGrFwkFmnrwb026YHU',
    authDomain: 'nishad-connect-e6d6c.firebaseapp.com',
    projectId: 'nishad-connect-e6d6c',
    storageBucket: 'nishad-connect-e6d6c.firebasestorage.app',
    messagingSenderId: '769812698353',
    appId: '1:769812698353:web:2cb3e4e56a6f008b8b4550',
    measurementId: 'G-9GNH7ZVTWH'
};

export const firebaseApp = initializeApp(firebaseConfig);

// Skipped during the react-snap prerender and on local dev so neither records page views or events.
const isLiveBrowser = typeof navigator !== 'undefined'
    && navigator.userAgent !== 'ReactSnap'
    && !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

export const analyticsPromise = isLiveBrowser
    ? isSupported().then((supported) => (supported ? getAnalytics(firebaseApp) : null))
    : Promise.resolve(null);

export const trackEvent = (name, params) => {
    analyticsPromise.then((analytics) => {
        if (analytics) logEvent(analytics, name, params);
    });
};
